"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.WarningMessage=exports.SubHeading1=exports.ErrorMessage=exports.CvvErrorMessage=exports.CreditText=exports.ButtonContainer=exports.AddDirectSpendCardForm=void 0;const ButtonContainer=exports.ButtonContainer=_styledComponents.default.div`
  align-items: center;
  display: grid;
`,WarningMessage=exports.WarningMessage=_styledComponents.default.div`
  margin: 8px 0px;
  font-style: normal;
  font-weight: 300;
  font-size: 10px;
  line-height: 16px;
  color: #535250;
`,ErrorMessage=exports.ErrorMessage=_styledComponents.default.div`
  margin: 2px 0px 8px 0px;
  font-size: 12px;
  line-height: 18px;
  color: #C74E4E;
`,CvvErrorMessage=exports.CvvErrorMessage=_styledComponents.default.div`
margin: 2px 0px 8px 10px;
font-size: 12px;
line-height: 18px;
color: #C74E4E;
`,SubHeading1=exports.SubHeading1=_styledComponents.default.h1` font-style: normal;
font-weight: 600;
font-size: 24px;
line-height: 30px;
color: #2a2928;
margin-bottom:24px;
margin-top:unset;`,CreditText=exports.CreditText=_styledComponents.default.div` 
font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 24px;
color: #2a2928;
margin-top:24px`,AddDirectSpendCardForm=exports.AddDirectSpendCardForm=_styledComponents.default.div`
  overflow: hidden;
  padding:0px 12px;
  &.mobile{
    width:336px
  }
  .paymentMethodsModuleForm{
    /* padding: 0px 15px; */
    font-family: "Nunito Sans", Arial, Helvetica, sans-serif;
    font-feature-settings: "liga" off, "calt" off;
    font-style: normal;
    font-weight: normal;
    margin: 16px 0;
    color: #7D7B78;
    max-width: 456px;
  }

  .paymentMethodsModuleForm .submitErrorMsg {
    color: #cc4545;
    font-family: "Nunito Sans", Arial, Helvetica, sans-serif;
    font-size: 12px;
  }

  .paymentMethodsModuleForm .crossIcon{
    color: #fff;
    background-color: #dd1e25;
    border-radius: 50%;
    padding: 8px;
  }


  .paymentMethodsModuleForm .cVVInputContainer {
    margin-left: 12px;
  }

  .paymentMethodsModuleForm .inputContainer .input {
    box-shadow: none;
    border-radius: 8px;
    border: 1px solid #7d7b78;
    font-size: 16px;
    box-sizing: border-box;
    background: none;
    padding: 10px 16px;
    width: 100%;
    height: 56px;
    color: #2b0810;
  }

  .paymentMethodsModuleForm .inputContainer  {
    display: flex;
    flex-direction: column;
    position: relative;
  }

  .paymentMethodsModuleForm .inputContainer:focus-within label {
    transform: translate(0, 5px) scale(0.7);
  }

  .paymentMethodsModuleForm .inputContainer label {
    color: #7d7b78;
    padding: 0px 16px;
    position: absolute;
    transform: translate(0, 19px) scale(1);
    transform-origin: top left;
    transition: all 0.2s ease-out;
    z-index: -1;
  }

  .paymentMethodsModuleForm .inputContainer .activeLabel {
    transform: translate(0, 5px) scale(0.72);
    padding-left:24px
  }
  .paymentMethodsModuleForm .inputContainer .activeCardNumberLabel {
    transform: translate(0px, 5px) scale(0.72);
    padding-left:13px;
    font-weight:normal;
  }

  .paymentMethodsModuleForm .inputContainer .input.error{
    border: 1px solid #cc4545;
    font-weight: normal;
  }

  .paymentMethodsModuleForm .inputContainer .input:focus,
  .paymentMethodsModuleForm .inputContainer .input.error:focus {
    border: 0px solid #3E7CA8 !important;
    outline: #3E7CA8 solid 2px !important;
  }

  .paymentMethodsModuleForm .cardNumberContainer {
    display: flex;
    border: 1px solid #7d7b78;
    box-sizing: border-box;
    border-radius: 8px;
    /* margin: 16px 8px 0px 8px; */
    box-shadow: none;
    font-size: 16px;
    color: #2b0810;
    text-align: left;
    align-items: center;
    justify-content: left;
    padding-right: 2px;
  }

  .paymentMethodsModuleForm .cardNumberContainer.error  {
    border: 1px solid #cc4545;
    font-weight:normal;
  }

  .paymentMethodsModuleForm .cardNumberContainer:focus-within,
  .paymentMethodsModuleForm .cardNumberContainer.error:focus-within {
    border: 0px solid #3E7CA8 !important;
    outline: #3E7CA8 solid 2px !important;
  }

  .paymentMethodsModuleForm .cardNumber {
    height: 36px;
    box-sizing: border-box;
    border: none !important;
    font-size: 16px;
    margin: 10px 8px;
    width: 100%;
    background: none;
    outline: none !important;
    color: rgb(43, 8, 16);
  }

  .paymentMethodsModuleForm .cardNumber:focus {
    outline: none !important;
  }

  .paymentMethodsModuleForm .monthCVVContainer{
    display: flex;
  }

  .paymentMethodsModuleForm .ctnBtnContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .backdrop{
    z-index: 5 !important;
  }
`;